import { connect } from 'react-redux'
import AuteurBioBiblio from './AuteurBioBiblio.jsx'
import { fetchBioBiblio, saveBiblio } from '../actions/auteur.js'

const mapStateToProps = (state) => {
    return {
        'which' : 'Bibliographie',
        'loginok' : state.loginok,
        'data': state.biblio,
        'loading' : state.loading,
        'processing' : state.processing,
        'error' : state.error
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        'fetch' : (id) => {
            dispatch(fetchBioBiblio(id));
        },
        'save' : (id,html) => {
            return dispatch(saveBiblio(id,html));
        }
    }
}

const AuteurBiblioContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AuteurBioBiblio);

export default AuteurBiblioContainer


// WEBPACK FOOTER //
// ./auteur/biobiblio/AuteurBiblioContainer.jsx